// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyDJtQe-bdltoV3q2iiHdukTGhriPFwZoco",
    authDomain: "richard-193715.firebaseapp.com",
    databaseURL: "https://richard-193715-default-rtdb.firebaseio.com",
    projectId: "richard-193715",
    storageBucket: "richard-193715.appspot.com",
    messagingSenderId: "143018279457",
    appId: "1:143018279457:web:52ca3d9f8e1691d4965960",
    measurementId: "G-P7FGEYY7H6"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
